<template>
	<textarea
		:id="id"
		ref="textareaRef"
		:class="computedClasses"
		:name="name || undefined"
		:form="form || undefined"
		:value="modelValue ?? ''"
		:disabled="disabled"
		:placeholder="placeholder"
		:required="required || undefined"
		:autocomplete="autocomplete || undefined"
		:readonly="readonly || plaintext"
		:aria-required="required || undefined"
		:aria-invalid="computedAriaInvalid"
		:rows="rows || 2"
		:wrap="wrap || undefined"
		:style="computedStyles"
		@input="onInput"
		@change="onChange"
		@blur="onBlur">
	</textarea>
</template>

<script>
	export default {
		name: 'BFormTextarea',
		// Written for Vue 3 (modelValue v-model, class and style in $attrs), so skip the Vue 2 compat rewrites
		compatConfig: { MODE: 3 },
		props: {
			ariaInvalid: {
				type: [Boolean, String],
				default: undefined,
			},
			autocomplete: {
				type: String,
				default: undefined,
			},
			disabled: {
				type: Boolean,
				default: false,
			},
			form: {
				type: String,
				default: undefined,
			},
			id: {
				type: String,
				default: undefined,
			},
			modelValue: {
				type: String,
				default: '',
			},
			name: {
				type: String,
				default: undefined,
			},
			noResize: {
				type: Boolean,
				default: false,
			},
			placeholder: {
				type: String,
				default: undefined,
			},
			plaintext: {
				type: Boolean,
				default: false,
			},
			readonly: {
				type: Boolean,
				default: false,
			},
			required: {
				type: Boolean,
				default: false,
			},
			rows: {
				type: [String, Number],
				default: 2,
			},
			size: {
				type: String,
				default: undefined,
			},
			state: {
				type: Boolean,
				default: undefined,
			},
			wrap: {
				type: String,
				default: 'soft',
			},
		},
		emits: ['update:modelValue', 'input', 'change', 'blur'],
		computed: {
			computedAriaInvalid() {
				if (this.ariaInvalid !== undefined) {
					return this.ariaInvalid;
				}

				return this.state === false ? true : undefined;
			},
			computedClasses() {
				return [
					this.plaintext ? 'form-control-plaintext' : 'form-control',
					this.size ? `form-control-${this.size}` : null,
					{
						'is-valid': this.state === true,
						'is-invalid': this.state === false,
					},
				];
			},
			computedStyles() {
				return {
					resize: this.noResize ? 'none' : undefined,
				};
			},
		},
		methods: {
			onInput(event) {
				this.$emit('update:modelValue', event.target.value);
				this.$emit('input', event);
			},
			onChange(event) {
				this.$emit('change', event);
			},
			onBlur(event) {
				this.$emit('blur', event);
			},
			focus() {
				this.$refs.textareaRef?.focus();
			},
			blur() {
				this.$refs.textareaRef?.blur();
			},
		},
	};
</script>
